import { render, staticRenderFns } from "./MyFans.vue?vue&type=template&id=0f079e64&"
import script from "./MyFans.vue?vue&type=script&lang=js&"
export * from "./MyFans.vue?vue&type=script&lang=js&"
import style0 from "./MyFans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports